class Queue {
  //dã
  constructor() {

    this.alreadySet = false;
    this.historyEditor = [];
    this.historyEditorIndex = 0;
    this.computedElements = [];
    this.elementsControlerRedux = {};
    this.enable = false;
    this.processing = false;
  }

  //reducao do objecto multidimensional do editor para um objeto simples
  reduxx(arr) {
    this.elementsControlerRedux[arr.id] = JSON.parse(JSON.stringify(arr));
    if (typeof arr.childs != 'undefined' && arr.childs.length > 0) {
      for (let i in arr.childs)
        this.reduxx(arr.childs[i]);
    }
    return true;
  }

  //funcao principal que mantem as referencias dos itens e preenche o objeto redux
  addElements(elements) {
    //
    // if (!this.alreadySet) {
    //
    //   this.historyEditor = [];
    //   this.historyEditorIndex = 0;
    //   this.computedElements = [];
    //   this.elementsControlerRedux = {};
    //
    //   let elementsToRedux = JSON.parse(JSON.stringify(elements));
    //
    //   for (let j in elementsToRedux) {
    //     this.reduxx(elementsToRedux[j], j)
    //   }
    //   this.alreadySet = true;
    // }
  }

  log(id, value) {
    //console.log('log');
    // if (this.enable && !this.processing) {
    //
    //   //initial state
    //   if (this.computedElements.indexOf(id) === -1 && this.elementsControlerRedux[id]) {
    //
    //     let objInitialState = {};
    //     objInitialState['id'] = id.toString();
    //     objInitialState['type'] = 'elem';
    //     objInitialState['data'] = JSON.parse(JSON.stringify(this.elementsControlerRedux[id].config));
    //
    //     this.computedElements.push(id);
    //
    //     this.historyEditor.push(objInitialState);
    //
    //     this.historyEditorIndex++;
    //     this.historyEditor.splice(this.historyEditorIndex);
    //   }
    //
    //   this.historyEditorIndex++;
    //   this.historyEditor.splice(this.historyEditorIndex);
    //
    //   let obj = {};
    //   obj['id'] = id.toString();
    //   obj['type'] = 'elem';
    //   obj['data'] = JSON.parse(JSON.stringify(value));
    //
    //   this.historyEditor.push(obj);
    // }
  }

  logChilds(parentId, childs) {
    // if (this.enable && !this.processing) {
    //
    //   console.log('oi');
    //   //initial state
    //   if (this.computedElements.indexOf(parentId) === -1 && this.elementsControlerRedux[parentId]) {
    //     console.log('oi2');
    //
    //     let objInitialState = {};
    //     objInitialState['id'] = parentId.toString();
    //     objInitialState['type'] = 'panel';
    //     objInitialState['childs'] = JSON.parse(JSON.stringify(this.elementsControlerRedux[parentId].childs));
    //
    //     this.computedElements.push(parentId);
    //
    //     this.historyEditor.push(objInitialState);
    //
    //     this.historyEditorIndex++;
    //     this.historyEditor.splice(this.historyEditorIndex);
    //   }
    //
    //   this.historyEditorIndex++;
    //   this.historyEditor.splice(this.historyEditorIndex);
    //
    //   let obj = {};
    //   obj['id'] = parentId.toString();
    //   obj['type'] = 'panel';
    //   obj['childs'] = JSON.parse(JSON.stringify(childs));
    //
    //   this.historyEditor.push(obj);
    //
    //   this.enable = false;
    //
    //   console.log(this.historyEditor);
    // }
  }

  logEditor(elements) {
    // if (this.enable && !this.processing) {
    //
    //   this.historyEditorIndex++;
    //   this.historyEditor.splice(this.historyEditorIndex);
    //
    //   let obj = {};
    //   obj['type'] = 'editor';
    //   obj['elements'] = JSON.parse(JSON.stringify(elements));
    //
    //   this.historyEditor.push(obj);
    // }
  }

  undo() {
    if (this.enable && !this.processing) {

      if (this.historyEditorIndex > 0) {

        this.historyEditorIndex--;

        this.applyChange();

        setTimeout(() => {
          this.enable = true;
          this.processing = false;
        }, 500)
      }
    }
  }

  redo() {
    if (this.enable) {
      console.log(this.historyEditor, this.historyEditorIndex);
      if (this.historyEditor.length - 1 - this.historyEditorIndex > 0) {
        this.historyEditorIndex++;

        this.applyChange();

        console.log('redo');

        setTimeout(() => {
          this.enable = true;
          this.processing = false;
        }, 500)
      }
    }
  }

  applyChange() {
    //
    // this.processing = true;
    // console.log('apply')
    //
    // let elementToUpdate = JSON.parse(JSON.stringify(this.historyEditor[this.historyEditorIndex]));
    //
    // this.enable = false;
    //
    // console.log(elementToUpdate);
    //
    // if (elementToUpdate['type'] === 'elem')
    //   window.vm.$root.$emit('setConfigElement', elementToUpdate['id'], elementToUpdate['data']);
    // else {
    //   if(elementToUpdate['type'] === 'editor'){
    //     window.vm.$root.$emit('setElementsUndoRedo', elementToUpdate['elements']);
    //   }else{
    //     window.vm.$root.$emit('setChildsUndoRedo', elementToUpdate['id'], elementToUpdate['childs']);
    //   }
    // }
  }

  changePointerState(value) {
    // this.enable = value;
  }

  showHistory() {
    // console.log(this.historyEditor);
  }


}

export default Queue;



// WEBPACK FOOTER //
// ./src/js/base/Queue.js